import React, { FC, useState, useEffect } from "react"
import { BenchmarksCard } from "./BenchmarksCard"
import CarrierSpot from "@/public/icons/carrier-spot.svg"
import PriceRangeIcon from "@/public/icons/price-range.svg"
import BroncoHistoryIcon from "@/public/icons/bronco-history.svg"
import PriceRange1Icon from "@/public/icons/price-rang1.svg"
import PriceRange2Icon from "@/public/icons/price-rang2.svg"
import PriceRange3Icon from "@/public/icons/price-rang3.svg"
import { SalesUsMarketResponseData } from "@/lib/types"
import { dollarUS } from "@/lib/services"

type Props = {
  success: boolean
  listingData: SalesUsMarketResponseData
}

export const Benchmarks: FC<Props> = (props) => {
  return (
    <div
      className={
        (props.success ? "" : "opacity-50") +
        " relative lg:col-span-7 col-span-12"
      }
    >
      <div
        className={
          (props.success ? "hidden" : "block") +
          " absolute w-full h-full z-10 bg-blak"
        }
      ></div>
      <h1 className="dark:text-primary-10 text-light-2 2xl:text-28 text-2xl">Benchmarks</h1>
      <div className="md:gap-2 gap-5 grid grid-cols-2 ">
        <div className="xl:col-span-1 col-span-2">
          {props.listingData && "mexicoRates" in props.listingData && (
            <ul className="xl:w-full lg:w-[74%] md:w-[66%] w-full ml-auto flex md:justify-start justify-center dark:text-white text-light-2 border-0 mt-2 border-b-4 pb-3 border-secondary-3  "></ul>
          )}
        </div>
      </div>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
        <BenchmarksCard
          icon={CarrierSpot}
          title="DAT Broker-to-Carrier Spot"
          heading={props.listingData.DAT_Broker.reports}
          sub_heading="Past 3 Days / Market Area"
          icon2={PriceRangeIcon}
          para1={dollarUS.format(props.listingData.DAT_Broker.rateUsdPm)}
          para2={`(${dollarUS.format(props.listingData.DAT_Broker.lowUsdPm)}
           - ${dollarUS.format(props.listingData.DAT_Broker.highUsdPm)})`}
          icon3={PriceRange1Icon}
          para3={dollarUS.format(props.listingData.DAT_Broker.rateUsd)}
          para4={`(${dollarUS.format(
            props.listingData.DAT_Broker.lowUsd,
          )} - ${dollarUS.format(props.listingData.DAT_Broker.highUsd)})`}
        />
        {props.listingData &&
        Object.keys(props.listingData.BTS_History).length !== 0 ? (
          <BenchmarksCard
            icon={BroncoHistoryIcon}
            title="Bronco Company History"
            heading={props.listingData.BTS_History.reports}
            sub_heading="Past 30 Days / Market Area"
            icon2={PriceRange2Icon}
            para1={dollarUS.format(props.listingData.BTS_History.rateUsdPm)}
            para2={`(${dollarUS.format(
              props.listingData.BTS_History.lowUsdPm,
            )} - ${dollarUS.format(props.listingData.BTS_History.highUsdPm)})`}
            icon3={PriceRange3Icon}
            para3={dollarUS.format(props.listingData.BTS_History.rateUsd)}
            para4={`(${dollarUS.format(
              props.listingData.BTS_History.lowUsd,
            )} - ${dollarUS.format(props.listingData.BTS_History.highUsd)})`}
          />
        ) : (
          <BenchmarksCard
            icon={BroncoHistoryIcon}
            title="Bronco Company History"
            heading="-"
            sub_heading="Past 30 Days / Market Area"
            icon2={PriceRange2Icon}
            para1={`$0`}
            para2={`($0 - $0)`}
            icon3={PriceRange3Icon}
            para3={`$0`}
            para4={`($0 - $0)`}
          />
        )}
      </div>
    </div>
  )
}
